export default __webpack_public_path__ + "8fadecc78d7a8d21c5a0195e964a1f3e.svg";